<template>
  <div>
    <p style="margin-top:0pt; margin-bottom:7.8pt; text-align:center; line-height:20pt; widows:2; orphans:2"><span
        style="font-family:黑体; font-size:16pt; font-weight:bold; -aw-import:ignore">&nbsp;</span></p>
    <p style="margin-top:0pt; margin-bottom:7.8pt; text-align:center; line-height:20pt; widows:2; orphans:2"><span
        style="font-family:黑体; font-size:16pt; font-weight:bold">技术服务协议</span><span
        style="font-family:Calibri; font-size:12pt">&nbsp;</span></p>
    <p style="margin-top:0pt; margin-bottom:7.8pt; text-align:center; line-height:20pt; widows:2; orphans:2"><span style="font-family:楷体; font-size:12pt">编号：HN-JSFW-2022-02</span></p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span style="font-family:楷体; font-size:12pt">欢迎您与约购平台签署本《技术服务协议》（下称“本协议”），</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span
        style="font-family:楷体; font-size:12pt">本服务协议，是您使用浙江德清帅博健康科技有限公司（下称‘帅博’）的高能氢原子发生装置（以下简称‘设备’）时，由深圳前海汇能科技产业有限公司（以下简称为</span><span
        style="font-family:Calibri; font-size:12pt">“</span><span
        style="font-family:楷体; font-size:12pt">汇能科技</span><span
        style="font-family:Calibri; font-size:12pt">”</span><span
        style="font-family:楷体; font-size:12pt">）为您提供的设备使用培训及运营指导和门店管理、约购项目营销系统等技术系统进行合作的有关服务。您每次使用设备时须支付</span><span
        style="font-family:Calibri; font-size:12pt">1</span><span
        style="font-family:楷体; font-size:12pt">元的设备启动费（即系统维护费）。</span><span
        style="font-family:楷体; font-size:12pt; font-weight:bold">您有权选择同意或者不同意本协议，如您选择不同意本协议，您的</span><a
        href="https://publicmobile.yeahgo.com/web/pdf?url=https://pro-yeahgo-oss.yeahgo.com/publicMobile/pdf/SB-BSJ-FW-01.pdf"
        style="text-decoration:none"><span
          style="font-family:楷体; font-size:12pt; font-weight:bold; text-decoration:underline; color:#0000ff">《设备保证金及设备使用管理服务合同》</span></a><span
        style="font-family:楷体; font-size:12pt; font-weight:bold">将无法生效。当您选择同意本协议后，您自愿选择使用平台为您提供的约购项目营销系统，表示您已经完全了解并同意遵守和履行</span><a
        href="https://publicmobile.yeahgo.com/web/pdf?url=https://pro-yeahgo-oss.yeahgo.com/publicMobile/pdf/HN-YXXT-SYGZ-2022-01.pdf" style="text-decoration:none"><span
          style="font-family:楷体; font-size:12pt; font-weight:bold; text-decoration:underline; color:#0000ff">《约购项目营销系统使用规则》</span></a><span
        style="font-family:楷体; font-size:12pt; font-weight:bold">的全部内容。约购项目营销系统是设备保证金及使用管理服务合同及本协议不可分割的组成部分。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span style="font-family:楷体; font-size:12pt">一、服务期限：一年，自签署本协议生效之日起计算。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span style="font-family:楷体; font-size:12pt">二、服务费，以约购</span><span
        style="font-family:Calibri; font-size:12pt">APP</span><span
        style="font-family:楷体; font-size:12pt">线上支付页面显示的金额为准。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span style="font-family:楷体; font-size:12pt">三、服务内容：约购平台提供线上线下关于设备使用的培训及相关技术支持服务。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span style="font-family:楷体; font-size:12pt">四、约购平台为您提供的有关账号，由您自行设置并保管。因您保管账户、密码不当而造成的所有后果，将由您自行承担。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span
        style="font-family:楷体; font-size:12pt">五、您不得利用约购平台进行任何形式的洗钱活动。约购平台将严密监控此类行为，并有权配合主管机关的调查提交您的身份资料、有关账户的交易记录等信息。</span>
    </p>
    <p style="margin-top:0pt; margin-bottom:15.6pt; text-indent:24pt; line-height:20pt; widows:2; orphans:2"><span
        style="font-family:楷体; font-size:12pt">六、您同意严格遵守约购平台的个人信息（隐私）保护之全部内容。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span
        style="font-family:楷体; font-size:12pt">七、本协议未明示授权的其他权利仍由约购平台保留，您在行使这些权利时须另外取得约购的书面许可。约购如果未行使前述任何权利，并不构成对该权利的放弃。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:7.8pt; text-indent:24pt; text-align:left; line-height:20pt; widows:2; orphans:2; background-color:#ffffff">
      <span style="font-family:楷体; font-size:12pt">八、当您在线支付并点击签署本协议，即视为您完全同意本协议，本协议立即生效，一旦支付后，不退款。</span><span
        style="font-family:Calibri; font-size:12pt">&nbsp;</span><span
        style="font-family:Calibri; font-size:12pt">&nbsp;</span><span style="font-family:楷体; font-size:12pt"> </span>
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
div {
  background: #fff;
}
</style>